var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: _vm.cols,
            "form-context": _vm.formContext,
            icon: "inticon-autoclaim_company_group",
            title: "Zuweisungen",
          },
          on: { save: _vm.saveFirmAssignments },
        },
        [
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Haftpflicht-Rechtsanwälte",
                  "options-loader": _vm.loadLawyersOptions,
                  property: "casualtyLawyers",
                  type: "multiselectsearchable",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Kasko-Rechtsanwälte",
                  "options-loader": _vm.loadLawyersOptions,
                  property: "comprehensiveLawyers",
                  type: "multiselectsearchable",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Inkasso-Rechtsanwälte",
                  "options-loader": _vm.loadLawyersOptions,
                  property: "debtCollectionLawyers",
                  type: "multiselectsearchable",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Regress-Rechtsanwälte",
                  "options-loader": _vm.loadLawyersOptions,
                  property: "regressLawyers",
                  type: "multiselectsearchable",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Abweichende Reparaturbetriebe",
                  "options-loader": _vm.loadDifferingRepairFirmsOptions,
                  property: "differingRepairFirms",
                  type: "multiselectsearchable",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "KARO-Lack",
                  "options-loader": _vm.loadPaintShopsOptions,
                  property: "paintShops",
                  type: "multiselectsearchable",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Logistiker",
                  "options-loader": _vm.loadLogisticiansOptions,
                  property: "logisticians",
                  type: "multiselectsearchable",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Aufbereiter",
                  "options-loader": _vm.loadDetailersOptions,
                  property: "detailers",
                  type: "multiselectsearchable",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Mietwagenunternehmen",
                  "options-loader": _vm.loadCarRentalCompaniesOptions,
                  property: "carRentalCompanies",
                  type: "multiselectsearchable",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Callcenter",
                  "options-loader": _vm.loadCallcenterOptions,
                  property: "callcenter",
                  type: "autocomplete",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }